export const pt = {
  title: '',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Função',
      value: 'Identifica áreas de cobertura arbórea',
    },
    {
      label: 'Resolução',
      value: '30 × 30 metros',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Terra global (excluindo Antártica e ilhas do Ártico)',
    },
    {
      label: 'Fonte',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Frequência de atualizações',
      value: '',
    },
    {
      label: 'Dados de conteúdo',
      value: '2000 & 2010',
    },
    {
      label: 'Precauções',
      value:
        'Para efeitos deste estudo, a "cobertura arbórea" foi definida como toda a vegetação mais alto do que 5 metros de altura. A "cobertura arbórea" é a presença biofísica de árvores e pode assumir a forma de florestas naturais ou plantações existentes sobre uma gama de densidades de dosséis.',
    },
    {
      label: 'Licença',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Visão geral',
    value:
      'Este conjunto de dados, uma colaboração entre o laboratório GLAD (Análise Global de Terras; Descoberta) da Universidade de Maryland, Google, USGS e NASA, exibe a cobertura florestal global da terra (exceto para a Antártica e vários das ilhas árticas) para os anos de 2000 e 2010 com resolução de 30 × 30 metros. “Porcentagem de cobertura de árvores” é definida como a densidade da cobertura das copas das árvores da superfície da terra e é codificada por cores por colchetes de densidade (veja a legenda).\n\nOs dados nesta camada foram gerados usando imagens de satélite multiespectrais do mapeador temático plus (ETM +)Landsat 7. As observações claras da superfície de mais de 600 mil imagens foram analisadas usando o Google Earth Engine, uma plataforma em nuvem para observação da Terra e análise de dados, para determinar a cobertura da árvore por pixel usando um algoritmo de aprendizado supervisionado.\n\nA densidade da copa das árvores dos dados exibidos variam de acordo com a seleção. Use a legenda do mapa para alterar o limite mínimo de densidade da copa das árvores.',
  },
  citation: {
    label: 'Citação',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
